import React, { useMemo, useContext, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { useForm, FormProvider } from 'react-hook-form';
import { CoreContext } from './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';
import './index-nNbKOeeS.js';
import 'next/router';
import useShowError from './hooks/useShowError.js';
import 'notistack';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-kA_hdoOI.js';
import 'lodash';
import './utils/currency.js';
import 'next/server';
import './index-Oip0gjfj.js';
import { getInitialValues, validationSchema } from './components/ShoppingCart/ShoppingCartContentDrawer/ShoppingCartItemDrawer/Quantity/QuantityForm/form/index.js';
import InputQuantity from './components/inputs/InputQuantity/index.js';
import AutoSubmit from './components/inputs/AutoSubmit/index.js';

const Quantity = ({ quantity, labelExtra, onUpdateQuantity, setKey }) => {
    const { t } = useTranslation('', { keyPrefix: '$common' });
    const { t: tValidation } = useTranslation('', { keyPrefix: '$common.$validation' });
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const initialValues = useMemo(() => getInitialValues(quantity), [quantity]);
    const showErrorNotify = useShowError();
    const formMethods = useForm({
        resolver: validationSchema,
        defaultValues: initialValues,
        mode: 'onSubmit',
    });
    const { control, formState: { errors }, watch, } = formMethods;
    const { data: { siteConfig: { cart: { counterButtons = false, staticQuantity = false } = {} }, }, } = useContext(CoreContext);
    const quantityVal = Number(watch('quantity'));
    useEffect(() => {
        if (quantity !== quantityVal) {
            // we use this to re render QuantityForm whenever the quantity changes
            // in the drawer because of a new item added from the Featured products component
            // useForm saves initial state in cache so the quantity wouldn't update unless you close and open the drawer
            setKey(prev => prev + 1);
        }
    }, [quantity]);
    const increment = () => {
        if (quantity > 98) {
            showErrorNotify(tValidation('maximumQuantity'));
            return;
        }
        onUpdateQuantity(quantity + 1);
    };
    const decrement = () => {
        if (quantity === 1) {
            showErrorNotify(tValidation('minimumQuantity'));
            return;
        }
        onUpdateQuantity(quantity - 1);
    };
    const onSubmit = (values) => {
        if (!Number(values.quantity))
            return;
        onUpdateQuantity(Number(values.quantity));
    };
    return (React.createElement("div", { className: "quantity-counter" },
        counterButtons && (React.createElement("button", { className: "quantity-counter-btn minus", type: "button", disabled: quantityVal <= 1, onClick: decrement, "aria-label": t('quantityDecreaseBy', { productName: labelExtra }) },
            React.createElement("span", null, "-"))),
        staticQuantity && counterButtons ? (React.createElement("span", { className: "quantity-label" }, quantity)) : (React.createElement(FormProvider, { ...formMethods },
            React.createElement("form", null,
                React.createElement("fieldset", null,
                    React.createElement("legend", { className: "sr-only" }, tLabel('quantity')),
                    React.createElement(InputQuantity, { name: "quantity", labelExtra: labelExtra, control: control, errors: errors }),
                    React.createElement(AutoSubmit, { initialValues: initialValues, onSubmit: onSubmit }))))),
        counterButtons && (React.createElement("button", { className: "quantity-counter-btn plus", type: "button", onClick: increment, "aria-label": t('quantityIncreaseBy', { productName: labelExtra }) },
            React.createElement("span", null, "+")))));
};

export { Quantity as Q };
//# sourceMappingURL=QuantityForm-ouLDiYJU.js.map
